import { ChatClient } from "@ably/chat";
import { hookstate } from "@hookstate/core";
import * as Ably from "ably";

export const ablyStore = hookstate<{
  realtimeClient?: Ably.RealtimeClient;
  chatClient?: ChatClient;
}>({});
